import { IconButton } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'

import { DetailsLayout } from '../../components/detailsLayout/DetailsLayout'
import { isSpecialCasedSubTemplatedValueSetup } from '../../components/specialCasedSubTemplatedViewers/types'
import { TemplateDetailsContentSelector } from '../../components/templateDetails/content/TemplateDetailsContentSelector'
import { TemplateDetailsTitleSelector } from '../../components/templateDetails/title/TemplateDetailsTitleSelector'
import { useLayoutContext } from '../../context/layoutContext'
import { useTemplateContext } from '../../context/templateContext'
import { isNotRelevantField, isTemplateField } from '../../types/templateModel'

type Props = {
  onClose: () => void
}

export const TemplateDetailsRightSideBar = ({ onClose }: Props) => {
  const translate = useTranslate()
  const { viewingDetails, detailsPath, templateVersion } = useTemplateContext()
  const {
    preferences: {
      common: { isUsingModal },
    },
  } = useLayoutContext()

  return (
    <div className="relative size-full overflow-hidden flex flex-col">
      <IconButton
        className="absolute! right-2 top-2"
        onClick={onClose}
        iconSize="md"
        tip={translate('close')}
        iconName="XCircle"
      />
      {viewingDetails && !isUsingModal && templateVersion ? (
        <>
          <div className="flex flex-row items-center justify-between whitespace-break-spaces break-all p-2 pr-8 text-xl">
            <TemplateDetailsTitleSelector
              data={viewingDetails}
              layer={templateVersion.layer}
              block={templateVersion.block}
            />
          </div>
          <DetailsLayout
            isNotRelevant={
              isTemplateField(viewingDetails) &&
              isNotRelevantField(viewingDetails)
            }
            shouldSkipLayout={
              !!viewingDetails &&
              isSpecialCasedSubTemplatedValueSetup(viewingDetails)
            }
          >
            <TemplateDetailsContentSelector
              data={viewingDetails}
              // Some components of the details panel like the markdown editors are stateful so its important to unmount them
              // when the details path changes.
              key={detailsPath}
            />
          </DetailsLayout>
        </>
      ) : null}
    </div>
  )
}
